function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11 6H8V3H6v3H3v2h3v3h2V8h3z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#1d1d1b"
});

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14
  }, props), _ref);
}

export default __webpack_public_path__ + "1eb2099b78529251f84f7b780c0e613f.svg";
export { SvgPlus as ReactComponent };